export default __webpack_public_path__ + "static/media/science-n-faith.7960080c.jpg";